<script>
	// Components
	import TextInput from '@/Components/TextInput.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	import FontIcon from '@/Components/FontIcon.svelte';
	// Services
	import { notify } from '@/Services/Notify';
	// Stores
	import SportStore from '@/Stores/Sport/SportStore';
	import { mergeModelDataInCollectionStore } from '@/Stores/StoreHelpers';
	// Constants
	import { SportIcons } from '@/Constants/Icons';
	import Switch from '@/Components/Switch.svelte';

	export let sport;

	let errors = null;

	$: availableIcons = doIconMap();

	function doIconMap() {
		let iconArray = [];
		for (const iconName in SportIcons) {
			iconArray.push({ name: iconName, code: SportIcons[iconName] });
		}
		return iconArray;
	}

	function updateSport() {
		sport
			.patch({
				name: sport.name,
				icon: sport.icon,
				active: sport.active,
				cashout_enabled: sport.cashout_enabled
			})
			.then((response) => {
				notify({
					type: 'success',
					title: 'Sport successfully updated',
					message: `${sport.name} successfully updated!`,
					timeout: 3
				});
				mergeModelDataInCollectionStore(response, SportStore);
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: 'Problem updating sport',
					timeout: 3
				});
			});
	}
</script>

<div>
	<div class="flex items-end justify-end w-full">
		<button on:click={() => updateSport()} class="btn btn-primary"> Save </button>
	</div>
	<div class="w-1/3">
		<div class="grid grid-cols-3 gap-y-4">
			<div class="col-start-1 align-middle flex items-center">Name</div>
			<TextInput
				name="sportName"
				className="w-full text-left col-span-2"
				required={true}
				errors={errors && errors.name}
				placeholder="Enter sport name"
				bind:value={sport.name}
			/>
			<div class="col-start-1 align-middle flex items-center">Icon</div>
			<div class="flex flex-row text-left col-span-2">
				<SelectInput name="sportIcon" className="w-3/4" bind:value={sport.icon}>
					<option value={undefined}>Select Icon...</option>
					<option value={null}>No icon</option>
					{#each availableIcons as icon (icon.name)}
						{#if icon.name === sport.icon || icon.code === sport.icon}
							<option value={icon.code} selected>{icon.name}</option>
						{:else}
							<option value={icon.code}>{icon.name}</option>
						{/if}
					{/each}
				</SelectInput>
				<div class="w-1/4 text-center justify-center">
					{#if sport.icon}
						<div>
							{#key sport.icon}
								<FontIcon icon={sport.icon} className=" icon text-3xl" />
							{/key}
						</div>
					{/if}
				</div>
			</div>
			<div class="col-start-1 align-middle flex items-center">Active</div>
			<div class="flex flex-row text-left col-span-2">
				<Switch name="active" bind:checked={sport.active} small={false} />
			</div>
			<div class="col-start-1 align-middle flex items-center">Cashout Enabled</div>
			<div class="flex flex-row text-left col-span-2">
				<Switch name="cashout" bind:checked={sport.cashout_enabled} small={false} />
			</div>
		</div>
	</div>
</div>
